import { Typography } from '@kohler-dsm-library/kohler-core';
import { LocationIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './index.module.scss';

export const LocationPickButton = (props) => {
  const { text, className, ...rest } = props;
  return (
    <Typography component="button" type="button" size="overline" className={clsx(classes.locationPickButtonContainer, className)} {...rest}>
      <LocationIcon withBoundingBox={false} /> {text}
    </Typography>
  );
};